// extracted by mini-css-extract-plugin
export default {"error":"IFVkV","error-content":"WSyg7","error-content__text":"oUdb6"};